module.exports = __webpack_public_path__ + "img/calendar-icon.4c1033d0.png";